// extracted by mini-css-extract-plugin
export var searchHeader = "_6t-0";
export var searchHeaderDark = "_6t-1";